export { default as ComposedIdentityDocumentsWizard } from './IdentityDocumentsWizard';
export type { TIdentityDocumentsUploadConfig as TComposedIdentityDocumentsUploadConfig } from './types';
export { WizardProvider, useWizardContext } from './WizardContext';
export { identityUtils } from './utils';
